import { focusStyle } from "./fieldStyles";

const Checkbox = ({ formik, formClass, checkboxClass, label, valueName, style }) => {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "10px", ...style }}>
      <style>{focusStyle}</style>
      <input
        id={valueName}
        type="checkbox"
        name={valueName}
        checked={formik.values[valueName]}
        onChange={(e) => {
          formik.handleChange(e);
          formik.setFieldValue(valueName, e.target.checked);
        }}
        style={{
          width: "18px",
          height: "18px",
          accentColor: "#1a73e8",
          cursor: "pointer",
          flexShrink: 0,
          borderRadius: "4px",
        }}
      />
      {label && (
        <label htmlFor={valueName} style={{ fontSize: "0.9rem", color: "#424242", fontWeight: 500, cursor: "pointer", margin: 0 }}>
          {label}
        </label>
      )}
    </div>
  );
};

export default Checkbox;
